import React from "react";

export interface Props {
    name?: string,
    value?: string,
}

export function TraitCard({ name, value }: Props) {
    return <>
        <div
            className="flex flex-col space-y-2 rounded-2lg border border-jacarta-100 bg-light-base p-5 text-center transition-shadow hover:shadow-lg dark:border-jacarta-600 dark:bg-jacarta-900">
            <span className="text-sm uppercase text-jacarta-500">{name}</span>
            <span className="text-base text-jacarta-700 dark:text-white">{value}</span>
        </div>
    </>
}